export default __webpack_public_path__ + "static/media/VC.c12cfb83.svg";